/////////////////////////////////////////////////
// PADRÃO DOS PARCEIROS                       //
////////////////////////////////////////////////
const company = [
    {   type: 1,
        title: 'Contrato social',
        isRequired: true,
        hasTooltip: true,
        tooltipText: `Caso o Contrato seja superior a 03 (três) anos - <br>
                      enviar uma cópia simples da última alteração contratual, <br>
                      registrada em órgão competente ou Certidão Simplificada <br>
                      da Junta Comercial ou cartório de registro, conforme o caso.`
    },
    {   
        type: 2,
        title: 'Última atualização contratual (se houver)',
        isRequired: false,
        hasTooltip: false,
        tooltipText: ``
    },
    {   
        type: 3,
        title: 'Cartão CNPJ',
        isRequired: true,
        hasTooltip: true,
        tooltipText: `Cópia simples atualizada, emitida <br>
                      pelo site da Receita Federal.`
    },
    {
        type: 4,
        title: 'Ata de assembleia (se houver)',
        isRequired: false,
        hasTooltip: false,
        tooltipText: ``
    }
]

const companyPartner = [
    {   type: 5,
        title: 'Documento de identificação (RG. CPF e/ou CNH)',
        isRequired: true,
        hasTooltip: true,
        tooltipText: `Documento de Identificacão com <br>
                      validade de até 10 anos.`
    },
    {   
        type: 6,
        title: 'Comprovante de endereço',
        isRequired: true,
        hasTooltip: true,
        tooltipText: `Comprovante de endereço até <br>
                      90 dias após o vencimento.`
    },
    {   
        type: 7,
        title: 'Certidão de casamento (se aplicável)',
        isRequired: false,
        hasTooltip: true,
        tooltipText: `Certidão de Casamento <br>
                      (quando houver).`
    },
]

const companyPartnerPj = [...company]

const companyPartnerProcurator =  [
    ...companyPartner,
    {   type: 8,
        title: 'Procuração P.F. (aval) dos procuradores',
        isRequired: true,
        hasTooltip: true,
        tooltipText: `Cópia simples e atual, registrada <br>
                      em órgão competente.`
    },
]

/////////////////////////////////////////////////
// EXCLUSIVO CARBON                           //
////////////////////////////////////////////////
const companyCarbon = [
    ...company,
    {   
        type: 6,
        title: 'Comprovante de endereço',
        isRequired: true,
        hasTooltip: true,
        tooltipText: `Comprovante de endereço até <br>
                      90 dias após o vencimento.`
    },
    {   type: 9,
        title: 'Comprovante de dados bancários',
        isRequired: false,
        hasTooltip: false,
        tooltipText: ``
    },
]

const companyPartnerCarbon = companyPartner.filter(c => c.type !== 7)

const companyPartnerPjCarbon = companyCarbon.filter(c => c.type !== 10)

const companyPartnerProcuratorCarbon = companyPartnerProcurator.filter(c => c.type !== 7)

/////////////////////////////////////////////////
// EXCLUSIVO UNIVERSO                         //
////////////////////////////////////////////////
const companyUniverso = company.map(c => {
    const copy = { ...c }

    if (copy.type == 2) {
        copy.hasTooltip = true
        copy.tooltipText = `Caso a última alteração contratual tenha sido realizada há mais de 3 (três) anos – <br>
                         enviar a Certidão Simplificada, conforme o caso, emitida dentro dos últimos 90 (noventa) dias.`
    } else if (copy.type == 3) {
        copy.tooltipText = 'Cartão CNPJ com emissão dentro dos últimos 90 dias.'
    } else if (c.type == 4) {
        copy.title = 'Ata de eleição'
    }
    return copy
})
companyUniverso.splice(2, 0, {
    type: 10,
    title: 'Certidão simplificada',
    isRequired: false,
    hasTooltip: true,
    tooltipText: `Certidão Simplificada com emissão dentro dos últimos 90 dias.`
})
companyUniverso.push(
    {
        type: 11,
        title: 'Balancete',
        isRequired: false,
        hasTooltip: true,
        tooltipText: `Recente - assinado pelo contador.`
    }, 
    {
        type: 12,
        title: 'Balanço e DRE',
        isRequired: false,
        hasTooltip: true,
        tooltipText: `Encerrado dos últimos 3 anos - assinado pelo contador.`
    },
    {
        type: 13,
        title: 'Declaração de Faturamento',
        isRequired: false,
        hasTooltip: true,
        tooltipText: `Dos últimos 12 meses - assinado pelo contador.`
    },
    {
        type: 14,
        title: 'Abertura do Endividamento',
        isRequired: false,
        hasTooltip: true,
        tooltipText: `Atual e detalhado - data base com defasagem máxima de 02 meses.`
    }
)

const companyPartnerUniverso = companyPartner.filter(c => c.type !== 6)

const companyPartnerPjUniverso = companyUniverso.filter(({ type }) => !([11, 12, 13, 14].includes(type)))

const companyPartnerProcuratorUniverso = [...companyPartnerProcurator]

const documentsList = {
    //Padrão dos Parceiros
    company,
    companyPartner,
    companyPartnerPj,
    companyPartnerProcurator,
    //Exclusivo Carbon
    companyCarbon,
    companyPartnerCarbon,
    companyPartnerPjCarbon,
    companyPartnerProcuratorCarbon,
    //Exclusivo Universo
    companyUniverso,
    companyPartnerUniverso,
    companyPartnerPjUniverso,
    companyPartnerProcuratorUniverso,
}

export default documentsList 